import styled from "styled-components";

import { smallScreen } from "../../../../shared/constants/screenSizes";

export const LoadingViewContainer = styled.div`
  align-items: center;
  display: flex;
  height: 580px;
  justify-content: center;

  @media screen and (max-width: ${smallScreen}px) {
    height: 100vh;
  }
`;
